module.exports = __webpack_public_path__ + "static/media/test4.ff4dd58e.jpeg";